import { useState, useEffect } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Row, Col, Modal, notification } from "antd";
import { setAllEmployees } from "../../redux/actions/mainAction";
import noadmin from "../../images/noadmin.gif";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const { confirm } = Modal;

const AdminsTable = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const { MainResponse } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  const userId = JSON.parse(localStorage.getItem("user"))._id;

  useEffect(() => {
    getEmployees(page);
  }, [page]);

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Özünüzü adminlikdən çıxara bilməzsiniz!",
    });
  };

  const showMakeAdminConfirm = (employeeName, id) => {
    confirm({
      centered: "centered",
      title: employeeName,
      icon: <ExclamationCircleFilled />,
      content: "Əməkdaşı admin etmək istədiyinizdən əminsiniz?",
      okText: "Admin et",
      okType: "danger",
      cancelText: "İmtina Et",
      onOk() {
        makeAdmin(id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const makeAdmin = async (id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/employee-makeadmin/${id}`,
      {
        method: "put",
        body: JSON.stringify({
          appRole: "Admin",
        }),
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    if (result) {
      getEmployees();
    }
  };

  const showDeleteAdminConfirm = (employeeName, id) => {
    confirm({
      centered: "centered",
      title: employeeName,
      icon: <ExclamationCircleFilled />,
      content: "Əməkdaşı adminlikdən çıxarmaq istədiyinizə əminsiniz?",
      okText: "Çıxar",
      okType: "danger",
      cancelText: "İmtina Et",
      onOk() {
        deleteAdmin(id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const deleteAdmin = async (id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/employee-deleteadmin/${id}`,
      {
        method: "put",
        body: JSON.stringify({
          appRole: "User",
        }),
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    if (result) {
      getEmployees();
    }
  };

  const getEmployees = async (page) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-employees/?page=${page}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      const result = await response.json();
      dispatch(setAllEmployees(result.employees));
      dispatch(setTriggerAnyEvent(Math.random()));
      setTotalPages(result.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {contextHolder}

      {MainResponse.allEmployees.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Ad və Soyad</th>
              <th>Şirkət</th>
              <th>Şöbə</th>
              <th>Vəzifə</th>
              <th>E-poçt</th>
              <th>Telefon</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          {MainResponse.allEmployees.map((employe, index) => (
            <tbody key={employe._id}>
              <tr>
                <td>{employe._id}</td>
                <td>{employe.employeeName}</td>
                <td>{employe.companyName}</td>
                <td>{employe.departmentName}</td>
                <td>{employe.positionName}</td>
                <td>{employe.employeeEmail}</td>
                <td>{employe.employeePhone}</td>
                <td>
                  {employe.appRole === "Admin" ? (
                    <Link
                      onClick={() => {
                        if (userId !== employe._id) {
                          showDeleteAdminConfirm(
                            employe.employeeName,
                            employe._id
                          );
                        } else {
                          openNotificationWithIcon("error");
                        }
                      }}
                      className="btn"
                    >
                      İstifadəçi Et
                    </Link>
                  ) : (
                    <Link
                      onClick={() =>
                        showMakeAdminConfirm(employe.employeeName, employe._id)
                      }
                      className="btn-del"
                    >
                      Admin Et
                    </Link>
                  )}
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      ) : (
        <div className="no-item">
          <Row>
            <Col span={24}>
              <div className="no-item">
                <img style={{ width: "342px" }} src={noadmin} alt="noadmin" />
              </div>
            </Col>
          </Row>
        </div>
      )}
      {totalPages > 0 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Əvvəlki
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={page === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Növbəti
          </button>
        </div>
      )}
    </>
  );
};

export default AdminsTable;
